import React, { Component } from 'react';
import { FormSpy } from 'react-final-form';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import omit from 'lodash/omit';


class AutoSaveToSession extends Component {
  
  constructor(props) {
    super(props)
    this.state = { values: props.values }
  }
  
  componentDidMount () {
    const { form } = this.props;
    const unsaved = this.getUnsavedChanges();
    
    if (form && unsaved){
      setTimeout( () => map(unsaved, (v, k) => form.change(k,v)) );
      // form.focus('settings.blocks');
    }
  }
  
  getUnsavedChanges () {
    const data = sessionStorage.getItem(this.props.id);
    try {
      const initialValues = this.props.initialValues || {}
      const res = JSON.parse(data);
      
      if (isEqual(omit(res, 'updated_at'), omit(initialValues, 'updated_at'))){
        return null;
      }
      else if ( initialValues.updated_at && new Date(res.updated_at) <= new Date(initialValues.updated_at) ){
        return null;
      }
      else{
        return res;
      }
    } catch (e) {
      return null;
    }
  }
  
  setUnsavedChanges (values) {
    return sessionStorage.setItem(this.props.id, JSON.stringify({...values, updated_at: new Date().toISOString()}));
  }
  
  resetUnsavedChanges (values) {
    return sessionStorage.removeItem(this.props.id);
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucceeded === true){
      this.resetUnsavedChanges();
    }
    else{
      this.save()
    }
  }
  
  
  
  save () {
    const { values } = this.props
    
    if (!isEqual(this.state.values, values)) {
      this.setUnsavedChanges(values);
      this.setState({ values });
    }
  }

  render() {
    return null
  }
}


export default props => (
  <FormSpy {...props} subscription={{ values: true, submitSucceeded: true }} component={AutoSaveToSession} />
)


// WEBPACK FOOTER //
// ./src/components/form/AutoSaveToSession.js